var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isFromDocument)?_c('div',{class:_vm.data && _vm.data.validations.vertical_line ? 'vertical-line' : 'horizontal',style:(_vm.getStyle)}):(_vm.isFromDocument)?_c('div',{class:_vm.data && _vm.data.vertical_line ? 'vertical-lineDocs' : 'horizontalDocs',style:(_vm.getStyle)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }